var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeatherColdTemperature = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 21,
  fill: "none",
  viewBox: "0 0 13 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M8 0a2 2 0 0 1 2 2v9.416A5.001 5.001 0 0 1 8 21a5 5 0 0 1-2-9.584v-1.25L4.925 9.091v1.875H4.04V9.09l-1.454 1.455-.648-.636 2.102-2.08v-.905h-.905l-2.08 2.101L.42 8.38l1.455-1.455H0V6.04h1.875L.42 4.587l.636-.648 2.08 2.102h.905v-.905l-2.102-2.08.648-.636L4.04 3.875V2h.884v1.875L6 2.8V2a2 2 0 0 1 2-2m0 9a.5.5 0 0 0-.5.5v4.565A1.999 1.999 0 1 0 10 16c0-.932-.638-1.712-1.5-1.935V9.5A.5.5 0 0 0 8 9M4.925 6.925v.905L6 8.894V7.096l-.17-.171zm0-1.79v.906h.905L6 5.869V4.071z",
  clipRule: "evenodd"
})));
export default SvgWeatherColdTemperature;